/**
 * As cores do papel do exame (`apps/api/services/exame_digital_v3_cores.py`), para o documento na
 * mesa ter a mesma hierarquia do PDF (E202.F1, GUS-145). O texto e o fundo de cada trecho e de cada
 * célula vêm do próprio documento; aqui ficam só os títulos e os filetes que a mesa desenha.
 */
export const PALETA = {
  navy: '#0E2748',
  navy2: '#1D3A63',
  ciano: '#00A3C4',
  tinta: '#172131',
  mudo: '#667286',
  linha: '#D9DFE8',
  linha2: '#EBEFF4',
  superficie: '#F5F7FA',
} as const;

/** O corpo do texto corrido do exame, em pontos: o tamanho de cada trecho é relativo a ele. */
export const CORPO_PT = 7.4;
